<template>
  <div class="mobile-filters-panel-layout">
    <button
      v-if="isOpen"
      type="button"
      class="mobile-filters-backdrop d-lg-none"
      @click="$emit('close')"
    />
    <aside class="mobile-filters-panel" :class="{ 'is-open': isOpen }">
      <div class="mobile-filters-panel-header d-lg-none">
        <h3>{{ title }}</h3>
        <button
          type="button"
          class="mobile-filters-close"
          aria-label="Close filters"
          @click="$emit('close')"
        >
          <span class="mobile-filters-close-icon" aria-hidden="true">&times;</span>
        </button>
      </div>
      <slot />
    </aside>
  </div>
</template>

<script>
export default {
  name: 'MobileFiltersPanel',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.mobile-filters-panel-layout,
.mobile-filters-panel {
  width: 100%;
}

.mobile-filters-panel-header,
.mobile-filters-backdrop {
  display: none;
}

@media (max-width: 991px) {
  .mobile-filters-panel-layout {
    height: 0;
  }

  body.mobile-filters-open {
    overscroll-behavior: none;
    touch-action: none;
  }

  .mobile-filters-backdrop {
    background: rgba(15, 23, 42, 0.4);
    border: 0;
    display: block;
    inset: 0;
    position: fixed;
    z-index: 1040;
  }

  .mobile-filters-panel {
    background: #F8F8F8;
    bottom: 0;
    max-width: 34rem;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    overflow-y: auto;
    position: fixed;
    right: 0;
    top: 0;
    -ms-overflow-style: none;
    scrollbar-width: none;
    transform: translateX(100%);
    transition: transform 0.25s ease;
    width: min(34rem, 100vw);
    z-index: 1050;
  }

  .mobile-filters-panel::-webkit-scrollbar {
    display: none;
  }

  .mobile-filters-panel.is-open {
    box-shadow: -16px 0 40px rgba(15, 23, 42, 0.18);
    transform: translateX(0);
  }

  .mobile-filters-panel-header {
    align-items: center;
    background: #F8F8F8;
    border-bottom: 1px solid #d9e3eb;
    display: flex;
    justify-content: space-between;
    left: 0;
    padding: 1.3rem 4.8rem 1.3rem 1.4rem;
    position: sticky;
    right: 0;
    top: 0;
    z-index: 1;
  }

  .mobile-filters-panel-header h3 {
    color: #1f2933;
    flex: 1 1 auto;
    font-size: 1.75rem;
    font-weight: 700;
    margin: 0;
    text-transform: uppercase;
  }

  .mobile-filters-close {
    align-items: center;
    background: transparent;
    border: 0;
    color: #5b6773;
    display: inline-flex;
    font-size: 1rem;
    height: 3.2rem;
    justify-content: center;
    line-height: 1;
    padding: 0;
    position: absolute;
    right: 1.2rem;
    top: 50%;
    transform: translateY(-50%);
    width: 3.2rem;
  }

  .mobile-filters-close-icon {
    display: block;
    font-size: 2.8rem;
    font-weight: 400;
    line-height: 1;
  }

  .mobile-filters-panel .sidebar-wrapper {
    min-height: 100%;
    padding: 1.8rem 1.2rem 1.4rem;
  }

  .mobile-filters-panel .widget-body,
  .mobile-filters-panel .custom-control-label,
  .mobile-filters-panel .filter-price-text,
  .mobile-filters-panel .form-control {
    font-size: 1.48rem;
    line-height: 1.3;
  }

  .mobile-filters-panel .btn {
    font-size: 1.4rem;
    line-height: 1.2;
  }

  .mobile-filters-panel .widget {
    margin-bottom: 1rem;
    padding: 0 0 1rem;
  }

  .mobile-filters-panel .widget-title {
    font-size: 1.86rem;
    line-height: 1.25;
  }

  .mobile-filters-panel .widget-title a {
    padding-right: 2.2rem;
  }

  .mobile-filters-panel .widget-title a:before,
  .mobile-filters-panel .widget-title a:after {
    right: 0.4rem;
  }

  .mobile-filters-panel .widget-body {
    padding-top: 1.4rem;
    padding-left: 0.8rem;
  }

  .mobile-filters-panel .filter-price-action {
    align-items: flex-start;
    margin-top: 1.2rem;
    padding-bottom: 0.3rem;
  }

  .mobile-filters-panel .filter-price-text {
    margin-bottom: 0.8rem;
  }

  .mobile-filters-panel .category-checkbox {
    margin-bottom: 0.25rem;
  }

  .mobile-filters-panel .custom-control {
    margin-top: 0;
    margin-bottom: 0;
    min-height: 2rem;
    padding-left: 2.6rem;
  }

  .mobile-filters-panel .custom-control-label {
    margin-top: 0;
    padding-top: 0;
    position: static;
  }

  .mobile-filters-panel .custom-control-label::before,
  .mobile-filters-panel .custom-control-label::after {
    left: 0;
    top: 0.1rem;
    width: 1.8rem;
    height: 1.8rem;
  }

  .mobile-filters-panel .d-flex + .d-flex,
  .mobile-filters-panel .d-flex + .d-flex.flex-row-reverse {
    margin-top: 0.7rem;
  }

  .mobile-filters-panel .price-range-min,
  .mobile-filters-panel .price-range-max {
    height: 3.6rem;
    padding: 0.6rem 0.8rem;
  }

  .mobile-filters-panel .btn.btn-sm {
    min-height: 3.6rem;
    padding: 0.7rem 1.4rem;
  }

  .mobile-filters-panel .custom-color-label {
    width: 4.6rem;
    height: 1.8rem;
  }

  .mobile-filters-panel .collapse.show {
    margin-top: 0;
  }
}
</style>
